import bulletIcon from "../../../assets/images/bullet-icon.png";
import linkIcon from "../../../assets/images/link-icon.png";
import { useState, useEffect } from "react";
import http from "../../../helpers/http";
import { Link } from "react-router-dom";
import { m } from "framer-motion";
import httpos from "../../../helpers/httpos";
import { propertyDetailsPath } from "../../../helpers/propertyDetailsLink";

// `property`: a search result with no parcel polygon on the map (its dot was
// clicked); it already carries its details id and address, like its result card.
const PopupContent = ({ feature, property }) => {
  const [encodedParcelNumber, setEncodedParcelNumber] = useState(null);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    if (property) {
      setEncodedParcelNumber(property.id);
      setAddress(property.title || "Address not available");
      return;
    }
    if (!feature || !feature.properties) return;

    const props = feature.properties;

    // Parcel identifier fallback (GA → AL)
    const parcelId =
      props.parcelnumb ||
      props.parcel_number ||
      props.apn ||
      props.geoid ||
      props.nullgeoid ||
      props.parcel_id ||
      props.fips ||
      props.pid ||
      props.parcel_no ||
      null;

    // Always build a fallback address from map data (AL-safe)
    const fallbackAddress = [
      props.address || props.address_al || props.address_so,
      props.city || props.city_owned || props.scity,
      props.state2 || props.state,
      props.szip || props.zip,
    ]
      .filter(Boolean)
      .join(", ");

    if (!parcelId) {
      console.warn("Parcel identifier missing:", props);
      setEncodedParcelNumber(-1);
      setAddress(fallbackAddress || "Address not available");
      return;
    }

    httpos
      .post("/createencodedparcelid", {
        parcel_geom: JSON.stringify(feature.geometry),
      })
      .then((res) => {
        if (res.data?.status === 0) {
          // Backend has no property details for this parcel (AL case)
          setEncodedParcelNumber(-1);
          setAddress(fallbackAddress || "Address not available");
          return;
        }

        setEncodedParcelNumber(res.data.encoded_parcel_id);
        setAddress(res.data.full_address || fallbackAddress || "Address not available");
      })
      .catch((err) => {
        console.error("Encoded parcel error:", err);
        setEncodedParcelNumber(-1);
        setAddress(fallbackAddress || "Address not available");
      });
  }, [feature, property]);

  return (
    <div style={{ padding: 10, minWidth: 220 }}>
      <div>Full Address:</div>
      <p style={styles.info}>{address || "..."}</p>

      <div style={styles.linkContainer}>
        {encodedParcelNumber === null && "Generating Link..."}

        {encodedParcelNumber === -1 && "Details not available"}

        {encodedParcelNumber &&
          encodedParcelNumber !== -1 && (
            <a
              style={styles.link}
              href={propertyDetailsPath(encodedParcelNumber)}
            >
              Property Details
            </a>
          )}
      </div>
    </div>
  );
};

export default PopupContent;

const styles = {
  info: {
    fontWeight: 500,
    fontSize: 14,
    color: "#000",
    opacity: 0.65,
    margin: 0,
    textTransform: "capitalize",
  },
  link: {
    fontWeight: 500,
    fontSize: 15,
    color: "white",
    textDecoration: "none",
  },
  linkContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#67773f",
    width: "100%",
    padding: 10,
    marginTop: 10,
    color: "white",
  },
};
